import React from "react";

class ClinicSolutions extends React.Component {
    render() {
        return (
            <>
                <div className="clinicsoldiv1back">
                    <div className="clinicsoldiv1padding">
                        <div>
                            <p>
                                The primary objective of independent medical practices is to
                                move patients through the practice efficiently and
                                easily.Research indicates managing cost effectiveness while
                                maintaining practice growth and patient satisfaction is one of
                                the biggest challenges faced by small clinics. Eventually, rapid
                                growth in number of patients without adequate scale up of
                                supporting systems induces gaps leading to poor service to
                                patients.Eventually, rapid growth in number of patients without
                                adequate scale up of supporting systems induces gaps leading to
                                poor service to patients.
                            </p>
                            <p>
                                Medna Data Systems brings in best practices and transforms the medical
                                practice into efficient digitalization, streamlines workflow,
                                better patient management/Satisfaction and pretty easy patient
                                flow in clinic which will help practice owner to improve their
                                services.
                            </p>
                            <p>
                                Knowing your patients are key component of our product with
                                multiple tools such as Health Bubble / Appointment Scheduling /
                                EMR / Reporting. Visual interactive dashboards and KPI will
                                drive information to decision maker.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="blueTextHeader">Appointment Scheduling and Billing</div>
                <p className="blueSubText">
                    Easy, robust and can be accessed through multiple faces of workflow
                    enables Patient / Clinic Receptionist /Clinic Doctor to schedule
                    appointment and make payment through personalized payment gateway.
                    Monitor patient needs, timing and better inform patients on any change
                    in doctor schedule, once in clinic premise manage their life cycle
                    through better queue management system. Billing the patient with right
                    information and ease of collecting various information to make
                    collection of billing claims easy and accurate. Provide needed
                    incentives and information to patient becomes key factor for patient
                    satisfaction from billing perspective.
                </p>

                <div className="blueTextHeader">Electronic Medical Records (EMR)</div>
                <p className="blueSubText">
                    Manage patients’ medical history through the EMR with configurable
                    multi-specialty support. EMR provides an easy way to access patient
                    summary while maintaining strong confidentiality of patient records
                    through role based access controls. Scan and upload documents to EMR
                    from visits to other clinics for documenting relevant medical history.
                    Covers all aspects such as chief complaints, investigations,
                    observations, treatments, clinical reminders, diagnosis and follow up
                    plans
                </p>

                <div className="blueTextHeader">Managing Multiple Locations</div>
                <p className="blueSubText">
                    One point access for clinics at multiple locations controlling the
                    clinic/s from anywhere using Role based access system for users like
                    front desk, doctors etc.
                </p>

                <div className="blueTextHeader">Ease of Integration</div>
                <p className="blueSubText">
                    Medna Data Systems provides various integration options with physical devices,
                    simple appointment queue management system integration with Kiosk,
                    bio-medical devices integration and having patient monitored passively
                    are key benefits of integrated solution. No Symptoms are ignored in
                    process of these integration.
                </p>
            </>
        );
    }
}
export default (ClinicSolutions);
